type Options = {
  zero?: string; // if count is zero what word should be used
  one?: string; // if count is one what word should be used
  two?: string; // if count is two and needs a specific word to be used
  many?: string; // if count >one what word should be used
};
/**
 * Example
 * zero = no crows
 * one = a crow
 * two || many = murder of crows
 */

const convertKeys = (count: number) => {
  switch (count) {
    case 0: {
      return 'zero';
    }
    case 1: {
      return 'one';
    }
    case 2: {
      return 'two';
    }
    default: {
      return null;
    }
  }
};

export type PluralizeUtilProps = {
  text: string;
  count: number;
  options?: Options; // when just adding an 's' isn't enough; see above
};

export const PluralizeUtil = ({ text, count, options }: PluralizeUtilProps) => {
  const cnt = Math.abs(count);

  let data = text;
  const key = convertKeys(cnt);

  if (key !== null && options?.[key]) {
    data = options[key];
  } else if (cnt >= 2 && options?.many) {
    data = options.many;
  } else if (cnt >= 2 || cnt === 0) {
    data = `${text}s`;
  }

  return data;
};
